import React from 'react';
import styled from 'styled-components';
import Button from '../Button';

const Wrapper = styled(Button)`
  animation: ${p => p.theme.appear} 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
  background-color: ${p => p.background};
  overflow: hidden;
`;

const Image = styled.div`
  background-size: cover;
  background-image: url(${p => p.theme.staticDir + p.src});
  width: 30px;
  height: 30px;

  ${p => p.theme.breakpoints.smallHeight} {
    width: 40px;
    height: 40px;
  }
  ${p => p.theme.breakpoints.mediumHeight} {
    width: 50px;
    height: 50px;
  }
`;

const Locked = styled.div`
  width: 34px;
  line-height: 30px;
  text-align: center;
  border: 2px solid ${p => p.color};
  color: ${p => p.color};
  border-radius: 15px;
  font-weight: bold;

  ${p => p.theme.breakpoints.smallHeight} {
    width: 44px;
    line-height: 40px;
  }
  ${p => p.theme.breakpoints.mediumHeight} {
    width: 54px;
    line-height: 50px;
  }
`;

function PowerIcon({
  color, id, unlocked, className, onClick,
}) {
  return unlocked ? (
    <Wrapper background={color} className={className} onClick={onClick}>
      <Image src={`assets/game/ui/powers/${id}.png`} />
    </Wrapper>
  ) : (
    <Locked color={color} className={className}>
      ?
    </Locked>
  );
}

export default styled(PowerIcon)`
  animation-delay: ${p => p.delay || 0}ms;
`;
